import { Builder } from '@builder.io/sdk';
import { ArticlesList } from './ArticlesList';
import { ARTICLES_LIST_NAME, SHOW_AS } from './ArticlesList.types';
import { BuilderInputOptions } from '@/types/builder';

const ArticleListConfig = {
  name: ARTICLES_LIST_NAME,
  friendlyName: 'Articles List',
  description: 'A grid of articles with pagination.',
  inputs: [
    {
      name: 'showAs',
      friendlyName: 'Display Layout',
      type: 'string',
      enum: [
        { label: 'Cards grid', value: SHOW_AS.CARDS },
        { label: 'Simple list', value: SHOW_AS.LIST },
        { label: 'Hub article list', value: SHOW_AS.HUB_LIST },
      ],
      defaultValue: SHOW_AS.LIST,
      helperText:
        'Cards grid = image cards in a 3-column grid · Simple list = title + date rows · Hub article list = title + date rows with a "Go to article" button',
    },
    {
      name: 'title',
      friendlyName: 'Section Title',
      type: 'richText',
      defaultValue: 'More <span style="color: #fe5000">[HUB NAME]</span> articles',
      helperText:
        'Heading above the article list. Rich-text formatting (colours, bold) is visible in "Hub article list" mode — other modes display plain text only.',
    },
    {
      name: 'buttonText',
      friendlyName: 'Button Label',
      type: 'string',
      defaultValue: 'Go to article',
      helperText: "Text shown on each row's button.",
      showIf: (options: BuilderInputOptions) => options?.get('showAs') === SHOW_AS.HUB_LIST,
    },
    {
      name: 'tagVariant',
      friendlyName: 'Tag Color',
      type: 'string',
      defaultValue: 'primary',
      enum: [
        { label: 'Orange (default)', value: 'primary' },
        { label: 'Purple (guides)', value: 'secondary' },
      ],
      helperText: 'Colour of the category tag on each card.',
      showIf: (options: BuilderInputOptions) => options?.get('showAs') === SHOW_AS.CARDS,
    },
  ],
};

Builder.registerComponent(ArticlesList, ArticleListConfig);
